import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component CrownSelectedIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <CrownSelectedIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <CrownSelectedIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CrownSelectedIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CrownSelectedIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M8.5 7.487L4.69 6.1a1 1 0 00-1.32 1.146L5 15h14l1.63-7.753A1 1 0 0019.31 6.1L15.5 7.487l-2.747-3.14a1 1 0 00-1.506 0L8.5 7.487zM19 17H5v1c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-1z"
        fillRule="nonzero"
      />
    </svg>
  )
);
CrownSelectedIcon.displayName = "CrownSelectedIcon";
export default CrownSelectedIcon;
